// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11CTg","clinicsSelect":"styles_clinicsSelect__2vuDj"};